module.exports = __webpack_public_path__ + "static/media/phone.1cb9bf2f.svg";